import { render, staticRenderFns } from "./TentativeEventsEdit.vue?vue&type=template&id=1ba4189d"
import script from "./TentativeEventsEdit.vue?vue&type=script&lang=js"
export * from "./TentativeEventsEdit.vue?vue&type=script&lang=js"
import style0 from "./TentativeEventsEdit.vue?vue&type=style&index=0&id=1ba4189d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports